import Enumerable from "linq";
import { GetEditInfo, util } from "..";
import * as sonbpIfconst from "../sonbpIf/base/constants";
import { constDialogMessage, dialogUtil } from "../util";
import { Logger } from "../util/logger";
import { BaseLogicClass } from "./edit.baseLogic";
import { EditConst, EDIT_MODE_KIND, kumihanHv, KUMIHAN_HV } from "./edit.const";
import { greetingTranEntityEx, kumihanContoroller, kumihanGreetingRequestParam, kumihanResponseParam } from "./edit.entity";
import { itemVenderProperty } from "./edit.sonbp_if";
import { editUtil } from "./edit.tool";

/**
 * あいさつ文関連の処理クラス
 * 
 * TODO ★名前に "Greeting"が付く関数は全てこちらへ移しています。
 * 
 */
export class GreetingLogicClass extends BaseLogicClass {

// #region ■定数・変数

    /**
     * あいさつ文最大数
     */
    private readonly GREETING_NUM_MAX: number = 10;

    /**
     * 組版トークン 
     */
    private get kumihanToken(): string {

        return this.editInfo.kumihanToken;
    }

    /**
     * WebAPI[Edit/GetEditInfo]のレスポンスのdata部
     */
    private get editInfo(): GetEditInfo.GetEditInfoResponseEntity {
        return this._edctrl.editInfo;
    }

// #endregion

// #region ■イベント

    /**
     * ツールメニュー：あいさつ文編集押下メソッド
     * @param selectedItemVp 選択済みアイテム（2025年対応：配置済み画像の再編集可能 #28295）
     * */
    public btnClickGreetingMenu(event: JQueryEventObject, selectedItemVp: itemVenderProperty = null): void {

        if (this._edctrl.editMode === EDIT_MODE_KIND.GREETING) {
            return;
        }

        // sonbpへ処理モード変更依頼
        this.sonbpIfController.setMode(EDIT_MODE_KIND.GREETING,
            () => {
                // 正常終了の場合
                this._edctrl.editMode = EDIT_MODE_KIND.GREETING;

                // あいさつ文パネルの初期化
                this.initGreetingPanel();

                if (this._usePcDesign) {
                    // PC用
                    // パネルの表示制御
                    this._vue.$data.Show.BalloonGuidance = false;
                    this._vue.$data.Show.PhotoList = false;
                    this._vue.$data.Show.OparatePallet = true;
                    this._vue.$data.Show.GreetingPanel = true;
                    this._vue.$data.Show.SenderPanel = false;
                    this._vue.$data.Show.StampPanel = false;
                    this._vue.$data.Show.MyStampPanel = false;
                    this._vue.$data.Show.TegakiStampPanel = false;

                    // ツールメニューの活性制御
                    this._vue.$data.ActiveSetPhotoMenu = false;
                    this._vue.$data.ActiveManiPhotoMenu = false;
                    this._vue.$data.ActiveGreetingMenu = true;
                    this._vue.$data.ActiveSenderMenu = false;
                    this._vue.$data.ActiveStampMenu = false;
                    this._vue.$data.ActiveMyStampMenu = false;
                    this._vue.$data.ActiveTegakiStampMenu = false;
                    this._vue.$data.ActiveFinishSelectMenu = false;

                    // フェードインアウトの初期化
                    this._vue.$data.HideLabel = EditConst.HIDE_AREA_FADE_OUT;
                    this._vue.$data.GreetingInfo.fade.In = false;
                    this._vue.$data.GreetingInfo.fade.Out = false;

                    // オブジェクト操作パレットの表示制御
                    this._edctrl.setModeOparatePallet(EDIT_MODE_KIND.GREETING, null);

                    if (selectedItemVp === null) {

                        // 先頭アイテム選択
                        this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_GREETING_TXT,
                            () => { Logger.debug("選択アイテムの指定 成功"); },
                            () => { },
                            () => { Logger.error("選択アイテムの指定 失敗"); }
                        );
                    } else {

                        // アイテム選択
                        this.sonbpIfController.selectItem(sonbpIfconst.ITYPE_GREETING_TXT, selectedItemVp.idx,
                            () => { Logger.debug("選択アイテムの指定 成功"); },
                            () => { Logger.error("選択アイテムの指定 失敗"); }
                        );
                    }
                }
                else {
                    // SP用

                    // 履歴処理開始
                    this.sonbpIfController.historyStart();

                    // ヘッダーメニュー
                    this._vue.$data.Show.ReturnFlowBtn = false;
                    this._vue.$data.Show.ReturnHomeBtn = false;
                    this._vue.$data.Show.NextFlowBtn = false;
                    this._vue.$data.Show.NextHomeFromImgListBtn = false;
                    this._vue.$data.Show.NextHomeFromMyStampListBtn = false;
                    this._vue.$data.Show.NextHomeFromTegakiStampListBtn = false;
                    this._vue.$data.Show.GreetingUpdataBtn = false;

                    // メインメニュー
                    this._vue.$data.Show.SetPhotoMenu = false;
                    // あいさつ文エリア
                    this._vue.$data.Show.GreetingPanel = false;
                    // 差出人エリア
                    this._vue.$data.Show.SenderPanel = false;
                    // スタンプエリア
                    this._vue.$data.Show.StampPanel = false;
                    this._vue.$data.Show.MyStampPanel = false;
                    this._vue.$data.Show.TegakiStampPanel = false;
                    this._vue.$data.Show.TegakiColorPanel = false;

                    this.sonbpIfController.getGreetingTextList((list: itemVenderProperty[]) => {
                        // 作成済みのあいさつ文が存在するか判定
                        if (0 < list.length) {
                            // 存在する場合、あいさつ文の位置調整表示
                            this._vue.$data.Header.Title = EditConst.TITLE_GREETING;

                            this._vue.$data.Show.ReturnGreetingHomeBtn = false;
                            this._vue.$data.Show.ReturnHomeExBtn = true;
                            this._vue.$data.Show.GreetingDeleteBtn = true;
                            this._vue.$data.Show.CommitNextHomeBtn = true;

                            this._vue.$data.Show.OparatePallet = true;

                            // オブジェクト操作パレットの表示制御
                            this._edctrl.setModeOparatePallet(EDIT_MODE_KIND.GREETING, null);

                            // タッチイベント制御(無効)
                            this._edctrl.touchEventChange(false);

                            if (selectedItemVp === null) {

                                // 先頭アイテムを選択
                                this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_GREETING_TXT,
                                    (selectItem: itemVenderProperty) => { Logger.debug("選択アイテムの指定 成功"); },
                                    () => { },
                                    () => { Logger.error("選択アイテムの指定 失敗"); });
                            } else {

                                // アイテム選択
                                this.sonbpIfController.selectItem(sonbpIfconst.ITYPE_GREETING_TXT, selectedItemVp.idx,
                                    () => { Logger.debug("選択アイテムの指定 成功"); },
                                    () => { Logger.error("選択アイテムの指定 失敗"); }
                                );
                            }
                        }
                        else {
                            // 存在しない場合、あいさつ文の編集表示
                            this.setGreetingEditMode(true);
                        }
                    });
                }

            },
            () => {
                // 異常終了の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHANGE_MODE, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
            });
    }

    /**
     * あいさつ文パネル フォント変更
     * @param event
     */
    public onChangeGreetingFont(event: JQueryEventObject): void {

        // フォントサンプル更新
        const font = this.editInfo.master.font.find(x => x.name == this._vue.$data.GreetingInfo.Font);
        if (font !== undefined) {
            this._vue.$data.GreetingInfo.FontSample = font.url;
        }
    }

    /**
     * あいさつ文パネル 文字レイアウト変更
     * @param event
     */
    public onChangeGreetingCharLayout(event: JQueryEventObject): void {
        // 行揃えコンボの切り替え(縦 or 横)
        if (this._vue.$data.GreetingInfo.CharLayout == EditConst.CHAR_LAYOUT_T) {
            this._vue.$data.GreetingInfo.ShowAlignY = false;
        }
        else {
            this._vue.$data.GreetingInfo.ShowAlignY = true;
        }
    }

    /**
     * あいさつ文パネル 例文を表示ボタン押下
     * @param event
     */
    public btnClickGreetingSample(event: JQueryEventObject): void {

        // 選択状態を初期化
        this.editInfo.master.greeting.forEach(row => row.selected = false);
        this._vue.$data.GreetingInfo.SampleList = this.editInfo.master.greeting;

        // 例文ダイアログ表示
        this._vue.$data.Show.MessageDialog = false;
        this._vue.$data.Show.GreetingDialog = true;
        this._vue.$data.Show.DialogArea = true;

        // 入力値が空であればデフォルトあいさつ文のセット
        if (this._vue.$data.GreetingInfo.Text == "") {
            let greetingNo = this.editInfo.master.design.greeting.no;
            Logger.info("デフォルトあいさつ文記号:", greetingNo);
            this.imgClickGreetingSample(greetingNo);
        }
    }

    /**
     * あいさつ文パネル 入力内容を適用するボタン押下
     *
     * @param requesNew ：true：新規、false：更新
     * @param event
     */
    public btnClickGreetingSet(requesNew: boolean, event: JQueryEventObject): void {

        let updateItemIdx: number = -1;

        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        // 上限チェック
        if (requesNew && (this.GREETING_NUM_MAX <= this.sonbpIfController.GreetingList.length)) {
            util.dialogUtil.createErrorDialog(
                constDialogMessage.WARN_EDIT_GREETING_MAX_NUM,
                () => {
                    // ローディングダイアログ終了
                    util.dialogUtil.closeLoading();
                    util.dialogUtil.closeErrorDialog();
                }
            );
            return;
        }

        let selectItem: itemVenderProperty = null;
        if (!requesNew) {
            // 選択あいさつ文の存在チェック
            selectItem = this.sonbpIfController.getSelectItem();

            // 選択アイテムが存在する場合、対応する入力データ(index)を取得
            if (selectItem !== null) {
                for (let i: number = 0; i < this.sonbpIfController.GreetingList.length; i++) {
                    if (this.sonbpIfController.GreetingList[i].id === selectItem.idx) {
                        updateItemIdx = i;
                        break;
                    }
                }
            }

            Logger.debug("選択あいさつ文 結果[" + updateItemIdx + "]");
        }

        // 入力値取得
        let setOrder: greetingTranEntityEx = this.getGreetingOrder();
        let msgList: string[] = [];

        // 入力チェック
        if (!this.validGreetingOrder(setOrder, msgList)) {
            // 入力チェックエラー
            util.dialogUtil.createErrorDialog(
                msgList.join("<br>"),
                () => {
                    // ローディングダイアログ終了
                    util.dialogUtil.closeLoading();
                    util.dialogUtil.closeErrorDialog();
                });
            return;
        }

        // ワイルドカード文字の検出
        const hasSampleWildCard = setOrder.text.indexOf(EditConst.GREETING_SAMPLE_WILDCARD, 0) === -1;
        const hasSampleWildCard2 = setOrder.text.indexOf(EditConst.GREETING_SAMPLE_WILDCARD2, 0) === -1;
        if (hasSampleWildCard && hasSampleWildCard2) {
            // 存在しない場合
            if (this._usePcDesign) {
                // PC用
                this.greetingSetFunc(requesNew, updateItemIdx, setOrder, null);
            }
            else {
                // SP用
                this.greetingSetFunc(requesNew, updateItemIdx, setOrder, () => { this.returnGreetingHomeBtn(null); });
            }
        }
        else {
            let message = "";
            if (!hasSampleWildCard) {
                // ●が残っています。
                message = constDialogMessage.INFO_EDIT_EXISTS_WILDCARDCHAR;
            } else {
                // ■が残っています。
                message = constDialogMessage.INFO_EDIT_EXISTS_WILDCARDCHAR2;
            }

            // 上記以外の場合、確認メッセージの表示
            util.dialogUtil.createYesNoDialog(
                message,
                () => {
                    util.dialogUtil.closeYesNoDialog();
                    if (this._usePcDesign) {
                        // PC用
                        this.greetingSetFunc(requesNew, updateItemIdx, setOrder, null);
                    }
                    else {
                        // SP用
                        this.greetingSetFunc(requesNew, updateItemIdx, setOrder, () => { this.returnGreetingHomeBtn(null); });
                    }
                },
                () => {
                    util.dialogUtil.closeLoading();
                    util.dialogUtil.closeYesNoDialog();
                },
                null,
                null,
                util.dialogUtil.DialogType.Infomation);
        }
    }

    /**
     * あいさつ文パネル 作成文章の削除ボタン押下
     * @param event
     */
    public btnClickGreetingDelete(event: JQueryEventObject): void {

        // 選択テキスト取得
        const selectItem: itemVenderProperty = this.sonbpIfController.getSelectItem();

        // sonbpへ削除依頼
        this.sonbpIfController.removeText(
            () => {
                // 正常終了の場合
                let idx = -1;
                for (let i: number = 0; i < this.sonbpIfController.GreetingList.length; i++) {
                    if (this.sonbpIfController.GreetingList[i].id == selectItem.idx) {
                        idx = i;
                    }
                }
                if (idx !== -1) {
                    this.sonbpIfController.GreetingList.splice(idx, 1);
                }

                // 選択アイテムの指定
                this.sonbpIfController.getGreetingTextList((textList: itemVenderProperty[]) => {
                    if (0 < textList.length) {
                        this.sonbpIfController.selectItem(textList[0].item_type, textList[0].idx, () => { }, () => { });
                    }
                    else {
                        // 0件になったら更新と削除を非活性
                        this._vue.$data.GreetingInfo.UpdBtnEnable = false;
                        this._vue.$data.GreetingInfo.DelBtnEnable = false;

                        if (!this._usePcDesign) {
                            // SP用
                            this._vue.$data.Show.OparatePalletCover = true;
                        }
                    }
                });

                if (!this._usePcDesign) {
                    // SP用
                    // 履歴処理開始(reset)
                    this.sonbpIfController.historyStart();
                    this._vue.$data.Show.ReturnHomeExBtn = false;
                }

            }, () => {
                // 上記以外の場合
                Logger.error("テキスト削除失敗 =>", selectItem);
            });

    }

    /**
     * あいさつ文パネル 例文表示ダイアログ OKボタン押下
     * @param event
     */
    public btnClickGreetingSampleOK(event: JQueryEventObject): void {

        const selectItem: GetEditInfo.GetEditInfoGreetingEntity = util.relic.listFind(this.editInfo.master.greeting, (g: GetEditInfo.GetEditInfoGreetingEntity) => {
            return g.selected === true;
        });

        if (selectItem === undefined) {
            util.dialogUtil.createErrorDialog(constDialogMessage.WARN_EDIT_NOSEL_GREETING_SAMPLE, dialogUtil.closeErrorDialog);
            return;
        }

        // 選択例文からワイルドカード文字を削除
        //const text = selectItem.text.split(EditConst.GREETING_SAMPLE_WILDCARD).join("");

        // 選択例文をテキストエリアに代入
        this._vue.$data.GreetingInfo.Text = selectItem.text;

        // 選択あいさつ文の文書文書番号保持
        this._vue.$data.GreetingInfo.SampleSelNo = selectItem.no;

        // 例文ダイアログクローズ
        this._vue.$data.Show.GreetingDialog = false;
        this._vue.$data.Show.DialogArea = false;
    }

    /**
     * あいさつ文パネル 例文表示ダイアログ キャンセルボタン押下
     * @param event
     */
    public btnClickGreetingSampleCancel(event: JQueryEventObject): void {
        // 例文ダイアログクローズ
        this._vue.$data.Show.GreetingDialog = false;
        this._vue.$data.Show.DialogArea = false;
    }

    /**
     * あいさつ文パネル 例文表示ダイアログ サンプル画像クリック
     * @param no
     */
    public imgClickGreetingSample(no: string): void {
        for (let i: number = 0; i < this.editInfo.master.greeting.length; i++) {
            if (this.editInfo.master.greeting[i].no === no) {
                this.editInfo.master.greeting[i].selected = true;
            }
            else {
                this.editInfo.master.greeting[i].selected = false;
            }
        }
        this._vue.$data.GreetingInfo.SampleList = this.editInfo.master.greeting;
    }

    /**
     * あいさつ文文字サイズ変更ボタンイベント
     * @param isPlus
     * @param event
     */
    public btnClickGreetingFontSize(isPlus: boolean, event: JQueryEventObject): void {

        const val = parseFloat(this._vue.$data.GreetingInfo.FontSize);
        if (isNaN(val)) return;

        if (isPlus) {
            if (val < EditConst.FONT_SIZE_MAX) {
                this._vue.$data.GreetingInfo.FontSize = val + EditConst.FONT_SIZE_STEP;
            }
        } else {
            if (EditConst.FONT_SIZE_MIN < val) {
                this._vue.$data.GreetingInfo.FontSize = val - EditConst.FONT_SIZE_STEP;
            }
        }
        return;
    }


    // #region ■イベント（SPのみ処理）

    /**
     * あいさつ文の位置調整画面に戻るボタン押下(SP)
     * @param event
     */
    public returnGreetingHomeBtn(event: JQueryEventObject): void {

        Logger.debug("あいさつ文の位置調整画面に戻るボタン押下");


        this.sonbpIfController.getGreetingTextList((list: itemVenderProperty[]) => {
            if (list.length === 0) {
                // あいさつ文が０件の場合には、ホームに戻る
                this._edctrl.btnClickReturnHome(true, true, null);
            }
            else {
                // タッチイベント制御(無効)
                this._edctrl.touchEventChange(false);

                // 履歴処理開始(reset)
                this.sonbpIfController.historyStart();

                // タイトル
                this._vue.$data.Header.Title = EditConst.TITLE_GREETING;

                // ヘッダメニュー
                this._vue.$data.Show.ReturnGreetingHomeBtn = false;
                this._vue.$data.Show.CommitNextHomeBtn = true;
                this._vue.$data.Show.GreetingDeleteBtn = true;
                this._vue.$data.Show.GreetingUpdataBtn = false;

                // あいさつ文パネル非表示
                this._vue.$data.Show.GreetingPanel = false;
                // 編集エリア表示
                this._vue.$data.Show.EditArea = true;

                // フッターメニュー
                this._vue.$data.Show.FooterMenu = true;
                this._vue.$data.Show.SetPhotoMenu = false;
                this._vue.$data.Show.EditImageMenu = false;
                this._vue.$data.Show.OparatePallet = true;

                // オブジェクト操作メニュー
                this._edctrl.setModeOparatePalletForSp(EDIT_MODE_KIND.GREETING, null);

                // あいさつ文の存在チェック
                this.sonbpIfController.getGreetingTextList((list: itemVenderProperty[]) => {
                    // 削除ボタンの活性制御
                    this._vue.$data.GreetingInfo.DelBtnEnable = (0 < list.length) ? true : false;
                });
            }
        });
    }

    /**
     * 操作パネル→あいさつ文アイテム編集ボタン押下メソッド(SP用)
     * */
    public btnClickEditGreetingItem(doAdd: boolean, event: JQueryEventObject): void {

        // タッチイベント制御(有効)
        this._edctrl.touchEventChange(true);

        this.setGreetingEditMode(doAdd);
    }

    // #endregion

// #endregion

// #region ■内部関数

    /**
     * あいさつ文編集モードへ画面項目設定(SP用)
     */
    private setGreetingEditMode(doAdd: boolean) {

        this._vue.$data.Header.Title = EditConst.TITLE_GREETING_EDIT;

        this._vue.$data.Show.ReturnHomeExBtn = false;
        this._vue.$data.Show.ReturnGreetingHomeBtn = true;
        this._vue.$data.Show.CommitNextHomeBtn = false;

        if (doAdd) {
            this._vue.$data.Show.GreetingUpdataBtn = false;
            // あいさつ文パネルの初期化
            this.initGreetingPanel();
        }
        else {
            this._vue.$data.Show.GreetingUpdataBtn = true;
            // 選択アイテムからのあいさつ文情報の復元
            const selectItem = this.sonbpIfController.getSelectItem();
            this.sonbpIfController.onChangeGreetingSelectItem(selectItem);
        }

        this._vue.$data.Show.FooterMenu = false;
        this._vue.$data.Show.EditArea = false;

        this._vue.$data.Show.GreetingPanel = true;

    }

    /**
     * あいさつ文パネルの初期化
     */
    private initGreetingPanel() {

        // パネルの入力情報を初期化

        // デフォルトフォント取得
        const defFont: GetEditInfo.GetEditInfoFontEntity = this._edctrl.getDefaultFont();

        // 共通
        this._vue.$data.GreetingInfo.Font = defFont.name;
        this._vue.$data.GreetingInfo.FontSample = defFont.url;
        this._vue.$data.GreetingInfo.OutlineFont = false;
        this._vue.$data.GreetingInfo.Text = "";
        this._vue.$data.SelectCharColor = this.editInfo.master.design.fontColor;
        this._vue.$data.SelectOutlineCharColor = this.editInfo.master.color[0].id;

        if (this.ExistsGreetingDesgin) {
            // デザイン定義ありの場合
            this._vue.$data.GreetingInfo.CharLayout = editUtil.directionToCharlayout(this.editInfo.master.design.greeting.direction);

            if (this.editInfo.master.design.greeting.direction === EditConst.DIRECTION_T) {
                // 縦書き指定
                this._vue.$data.GreetingInfo.AlignT = editUtil.alignToAlignDispVal(this._vue.$data.GreetingInfo.CharLayout, this.editInfo.master.design.greeting.align);
                this._vue.$data.GreetingInfo.AlignY = EditConst.ALIGN_Y_LEFT;
                this._vue.$data.GreetingInfo.ShowAlignY = false;
                this._vue.$data.GreetingInfo.FontSize = EditConst.FONT_SIZE_DEFAULT_T;
            }
            else {
                // 上記以外の場合
                this._vue.$data.GreetingInfo.AlignT = EditConst.ALIGN_T_TOP;
                this._vue.$data.GreetingInfo.AlignY = editUtil.alignToAlignDispVal(this._vue.$data.GreetingInfo.CharLayout, this.editInfo.master.design.greeting.align);
                this._vue.$data.GreetingInfo.ShowAlignY = true;
                this._vue.$data.GreetingInfo.FontSize = EditConst.FONT_SIZE_DEFAULT_Y;
            }
        }
        else {
            // 上記以外の場合
            this._vue.$data.GreetingInfo.ShowAlignY = false;
            this._vue.$data.GreetingInfo.CharLayout = EditConst.CHAR_LAYOUT_T;
            this._vue.$data.GreetingInfo.AlignT = EditConst.ALIGN_T_TOP;
            this._vue.$data.GreetingInfo.AlignY = EditConst.ALIGN_Y_LEFT;
            this._vue.$data.GreetingInfo.FontSize = EditConst.FONT_SIZE_DEFAULT_T;
        }

    }

    /**
     * あいさつ文デザイン定義の存在チェック
     */
    private get ExistsGreetingDesgin(): boolean {

        let exists = false;

        if (this.editInfo.master.design.greeting) {
            if (util.verify.isNotLengthZero(this.editInfo.master.design.greeting.direction)) {
                exists = true;
            }
        }

        return exists;
    }

    /**
     * あいさつ文生成処理
     *
     * @param requesNew     ：true：新規、false：更新
     * @param updateItemIdx ：更新対象のアイテムインデックス
     * @param setOrder      ：入力値
     * @param extraFunc     ：正常終了後に実行する処理
     */
    private greetingSetFunc(requesNew: boolean, updateItemIdx: number, setOrder: greetingTranEntityEx, extraFunc: () => void): void {

        // 組版パラメータ生成
        let kumihanParam: kumihanGreetingRequestParam = new kumihanGreetingRequestParam();
        // 組版トークン
        kumihanParam.session = this.kumihanToken;
        // 組方向
        kumihanParam.hv = (setOrder.charLayout == EditConst.CHAR_LAYOUT_T) ? KUMIHAN_HV.VERTICAL : KUMIHAN_HV.HORIZONTAL;
        // 文字サイズ
        kumihanParam.msize = setOrder.size;
        // 原点
        kumihanParam.pivot = editUtil.align2Pivot(kumihanParam.hv, setOrder.alignDispVal);
        setOrder.align = kumihanParam.pivot + "";

        // 決め打ちフラグ→trueであれば用紙のど真ん中に配置する
        let hasNoDesignMst = false;

        // 幅 高さ
        if (this.ExistsGreetingDesgin) {
            if (0 < this.editInfo.master.design.greeting.width && 0 < this.editInfo.master.design.greeting.height) {
                // デザインマスタに値セットされている場合
                const masterHv: kumihanHv = editUtil.directionToHv(this.editInfo.master.design.greeting.direction);
                if (kumihanParam.hv === masterHv) {
                    // 幅
                    kumihanParam.width = this.editInfo.master.design.greeting.width;
                    // 高さ
                    kumihanParam.height = this.editInfo.master.design.greeting.height;
                }
                else {
                    // 幅
                    kumihanParam.width = this.editInfo.master.design.greeting.height;
                    // 高さ
                    kumihanParam.height = this.editInfo.master.design.greeting.width;
                }
            } else {
                hasNoDesignMst = true;
            }
        }
        else {
            hasNoDesignMst = true;
        }

        if (hasNoDesignMst) {
            // デザインマスタに値がセットされていない→決め打ち
            if (kumihanParam.hv == KUMIHAN_HV.VERTICAL) {
                kumihanParam.width = EditConst.GREETING_DEFAULT_WIDTH;
                kumihanParam.height = EditConst.GREETING_DEFAULT_HEIGHT;

            } else {
                kumihanParam.width = EditConst.GREETING_DEFAULT_HEIGHT;
                kumihanParam.height = EditConst.GREETING_DEFAULT_WIDTH;

            }
        }

        // 組版時は用紙いっぱいに
        var psize = this.sonbpIfController.SonbpIf.getPageSize();
        if (psize.h >= psize.w) {
            // 縦書き
            kumihanParam.widthKumi = this.editInfo.greetingDefSize.shortSide;
            kumihanParam.heightKumi = this.editInfo.greetingDefSize.longSide;
        } else {
            // 横書き
            kumihanParam.heightKumi = this.editInfo.greetingDefSize.shortSide;
            kumihanParam.widthKumi = this.editInfo.greetingDefSize.longSide;
        }

        // フォント
        kumihanParam.ftype = setOrder.fontMaster.id;

        // 文字色
        kumihanParam.color1 = setOrder.fontColorMaster.rgb;
        if (setOrder.outlineChar) {
            // フチ文字色
            kumihanParam.color2 = setOrder.outlineFontColorMaster.rgb;
        }
        // 文章
        kumihanParam.payload = setOrder.text.split('\n');

        // 組版API呼び出し
        const kumihan: kumihanContoroller = new kumihanContoroller(this.editInfo.kumihanURL);
        kumihan.doKumihanGreeting(kumihanParam).then((result: kumihanResponseParam) => {
            // 結果判定
            if (result !== null) {
                this._vue.$data.EnableOnChangeForGreeting = false;

                if (requesNew) {
                    Logger.debug("あいさつ文 新規追加");
                    let newIdx = 1;
                    for (; newIdx <= this.GREETING_NUM_MAX; newIdx++) {
                        if (!Enumerable.from(this.sonbpIfController.GreetingList).firstOrDefault(row => Number(row.id) == newIdx, null)) {
                            break;
                        }
                    }
                    setOrder.id = newIdx.toString();
                    //console.log("newIdx", newIdx);

                    // 新規
                    this.sonbpIfController.setGreetingText(
                        setOrder.id,
                        true,
                        kumihanParam,
                        result.json,
                        hasNoDesignMst,
                        () => {
                            Logger.debug("あいさつ文 新規追加 正常終了");
                            // 正常終了の場合

                            // 入力内容の保持
                            this.sonbpIfController.GreetingList.push(setOrder);
                            this._vue.$data.GreetingInfo.SampleSelNo = "";
                            this._vue.$data.Show.OparatePalletCover4Top = false;
                            this._vue.$data.GreetingInfo.UpdBtnEnable = true;
                            this._vue.$data.GreetingInfo.DelBtnEnable = true;

                            this._vue.$data.EnableOnChangeForGreeting = true;

                            // ローディングダイアログ終了
                            util.dialogUtil.closeLoading();

                            if (extraFunc) {
                                extraFunc();
                            }
                        },
                        () => {
                            // 上記以外の場合
                            util.dialogUtil.closeLoading();
                            util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CREATE_GREETING, dialogUtil.closeErrorDialog);
                            this._vue.$data.EnableOnChangeForGreeting = true;
                        }
                    );
                }
                else {
                    Logger.debug("あいさつ文 既存更新 [" + updateItemIdx + "]");

                    // 更新
                    this.sonbpIfController.setGreetingText(
                        this.sonbpIfController.GreetingList[updateItemIdx].id,
                        false,
                        kumihanParam,
                        result.json,
                        hasNoDesignMst,
                        () => {
                            Logger.debug("あいさつ文 既存更新 正常終了");
                            // 正常終了の場合
                            setOrder.id = this.sonbpIfController.GreetingList[updateItemIdx].id;
                            if (util.verify.isLengthZero(setOrder.greetingNo)) {
                                setOrder.greetingNo = this.sonbpIfController.GreetingList[updateItemIdx].greetingNo;
                            }
                            this.sonbpIfController.GreetingList[updateItemIdx] = setOrder;
                            this._vue.$data.GreetingInfo.SampleSelNo = "";

                            this._vue.$data.EnableOnChangeForGreeting = true;

                            // ローディングダイアログ終了
                            util.dialogUtil.closeLoading();

                            if (extraFunc) {
                                extraFunc();
                            }
                        },
                        () => {
                            // 上記以外の場合
                            util.dialogUtil.closeLoading();
                            util.dialogUtil.createErrorDialog(
                                constDialogMessage.ERROR_EDIT_CREATE_GREETING,
                                () => {
                                    util.dialogUtil.closeErrorDialog();
                                    this._vue.$data.EnableOnChangeForGreeting = true;
                                });
                        }
                    );
                }
            }
            else {
                util.dialogUtil.closeLoading();
                util.dialogUtil.createErrorDialog(
                    constDialogMessage.ERROR_EDIT_CREATE_GREETING,
                    () => {
                        util.dialogUtil.closeErrorDialog();
                        this._vue.$data.EnableOnChangeForGreeting = true;
                    });
            }
        });

    }

    /**
     *  あいさつ文パネルの入力値を収集
     */
    private getGreetingOrder(): greetingTranEntityEx {

        let order: greetingTranEntityEx = new greetingTranEntityEx();

        // 入力値取得

        // 文字サイズ(有効値を格納するため、validGreetingOrder()側で格納します)
        //order.size = this._vue.$data.GreetingInfo.FontSize;

        // フォント
        let selFont: GetEditInfo.GetEditInfoFontEntity = util.relic.listFind(this.editInfo.master.font, (f: GetEditInfo.GetEditInfoFontEntity) => {
            return f.name === this._vue.$data.GreetingInfo.Font;
        });
        if (selFont !== undefined) {
            order.fontMaster = selFont;
        }

        // 文字色
        let selFontColor: GetEditInfo.GetEditInfoColorEntity = util.relic.listFind(this.editInfo.master.color, (c: GetEditInfo.GetEditInfoColorEntity) => {
            return c.id === this._vue.$data.SelectCharColor;
        });
        order.fontColorMaster = (selFontColor !== undefined) ? selFontColor : null;

        // 文字レイアウト
        order.charLayout = this._vue.$data.GreetingInfo.CharLayout

        // 行揃え
        if (order.charLayout === EditConst.CHAR_LAYOUT_Y) {
            order.alignDispVal = this._vue.$data.GreetingInfo.AlignY;
            order.direction = EditConst.DIRECTION_Y;
        }
        else {
            order.alignDispVal = this._vue.$data.GreetingInfo.AlignT;
            order.direction = EditConst.DIRECTION_T;
        }

        // フチ文字
        order.outlineChar = this._vue.$data.GreetingInfo.OutlineFont;
        if (order.outlineChar) {
            // フチ文字色
            let selOutlineFontColor: GetEditInfo.GetEditInfoColorEntity = util.relic.listFind(this.editInfo.master.color, (c: GetEditInfo.GetEditInfoColorEntity) => {
                return c.id === this._vue.$data.SelectOutlineCharColor;
            });
            order.outlineFontColorMaster = (selOutlineFontColor !== undefined) ? selOutlineFontColor : null;
        }

        // 文章
        order.text = this._vue.$data.GreetingInfo.Text;

        // 文書番号
        order.greetingNo = this._vue.$data.GreetingInfo.SampleSelNo;

        return order;
    }

    /**
     * あいさつ文の入力値チェック
     * @param order     ：チェック対象
     * @param msgList   ：エラーメッセージ
     */
    private validGreetingOrder(order: greetingTranEntityEx, msgList: string[]): boolean {

        var result: boolean = true;

        // 文字サイズ
        const fontSize: string = this._vue.$data.GreetingInfo.FontSize;
        if (util.verify.validFontSize(fontSize, msgList)) {
            order.size = Number(fontSize);
        }
        else {
            result = false;
        }

        // フォント
        // →未選択のないコンボなのでスキップ

        // 文字色
        if (order.fontColorMaster === null) {
            msgList.push(constDialogMessage.WARN_EDIT_INPUT_CHECK_CHARCOLOR);
            result = false;
        }

        // 文字レイアウト
        // →未選択のないコンボなのでスキップ

        // 行揃え
        // →未選択のないコンボなのでスキップ

        // フチ文字
        if (order.outlineChar && order.fontColorMaster === null) {
            msgList.push(constDialogMessage.WARN_EDIT_INPUT_CHECK_OUTCHARCOLOR);
            result = false;
        }

        // 文章
        if (order.text.length === 0) {
            msgList.push(constDialogMessage.WARN_EDIT_INPUT_CHECK_TEXT);
            result = false;
        }
        else {
            // 最大文字数チェック
            let aisatsuLenCheck = util.verify.validStringLen(order.text, EditConst.GREETING_MAXLEN);
            if (!aisatsuLenCheck) {
                msgList.push(constDialogMessage.WARN_EDIT_CHECK_GREETINGTEXT);
                result = false;
            }
            // 半角スペース、全角スペースのみの場合は組版させない。
            const texts = order.text.split("\n");
            if (!util.verify.validSpaceAll(texts)) {
                msgList.push(constDialogMessage.WARN_EDIT_INPUT_CHECK_TEXT);
                result = false;
            }
        }
        return result;
    }

// #endregion

}
